import Vue from 'vue'
require('bootstrap')
const app = new Vue({
    el: '#vue_menu',
});
